import BolaoDetalhe from "./boloes/BolaoDetalhe";

export default function BolaoDetalhePage() {
  return <BolaoDetalhe />;
}